import React, {ReactNode} from 'react';
import SidebarMenuContext from './utils/sidebarMenuContext';
import {useStoreActions, useStoreState} from 'store';
import {SidebarMenuSections} from './stores/sidebarMenu';
import {SidebarMenuSectionLabels} from './stores/sidebarMenuTranslations';
import Icon from '@/components/icons/Icon';


interface Props {
    name: SidebarMenuSections,
    icon?: string,
    children: ReactNode,
}

const SidebarMenuSection = React.memo<Props>((
    {
        name,
        icon,
        children,
    },
) => {
    const expandedMenuSection = useStoreState((state) => state.sidebarMenu.openSection);
    const setExpandedMenuSection = useStoreActions((actions) => actions.sidebarMenu.setOpenSection);

    const expanded = expandedMenuSection === name;

    let sectionClasses = '';
    let listClasses = 'collapse';
    if (expanded) {
        sectionClasses += ' active';
        listClasses += ' show';
    }

    const onClick = () => {
        if (expanded) {
            setExpandedMenuSection('');
        } else {
            setExpandedMenuSection(name);
        }
    };

    return (
        <li className={sectionClasses} data-cy={`menu-section-${name.split(' ').join('-').toLowerCase()}`}>
            <a
                onClick={onClick}
                href="#"
                title={name}
                className="has-arrow text-decoration-none"
            >
                {icon && <Icon name={icon as any} style={{marginRight: '8px'}} />}
                <span className="hide-menu">
                    {SidebarMenuSectionLabels[name] || name}
                </span>
            </a>
            <ul aria-expanded="false" className={listClasses}>
                <SidebarMenuContext.Provider value={name}>
                    {children}
                </SidebarMenuContext.Provider>
            </ul>
        </li>
    );
});

export default SidebarMenuSection;
